export enum ContentTypes {
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  APPLICATION_PDF = 'application/pdf',
}

export const extractFileExtension = (contentType: ContentTypes) => {
  const contentTypeMap = {
    [ContentTypes.IMAGE_JPEG]: 'jpg',
    [ContentTypes.IMAGE_PNG]: 'png',
    [ContentTypes.APPLICATION_PDF]: 'pdf',
  };

  return contentTypeMap[contentType];
};
